// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/monitoring/v2/aggregate_service.proto (package ai.h2o.mlops.monitoring.v2, syntax proto3)
/* eslint-disable */

import type { BaselineAggregation, ScoringAggregation } from "./aggregate_pb";
import type { BigIntString } from "../../../../../runtime";
import { RPC } from "../../../../../runtime";

/**
 * Request message for ListAggregates.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.ListAggregatesRequest
 */
export type ListAggregatesRequest = {
/**
 * Required. The parent resource name of the aggregates to list them from.
 * Format: `workspaces/{workspace}/deployments/{deployment}/experiments/{experiment}` or
 *         `workspaces/{workspace}/jobs/{deployment}/experiments/{experiment}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return less items then specified.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
/**
 * Supported filter fields:
 * - id
 * - logical_type
 * - timestamp >= 2023-12-30T23:59:43Z AND timestamp <= 2024-03-20T08:00:00Z
 * - column_name
 *
 * @generated from field: string filter = 4;
 */
filter?: string;
}
;
/**
 * Response message for ListAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.ListAggregatesResponse
 */
export type ListAggregatesResponse = {
/**
 * Scoring Aggregates
 *
 * @generated from field: repeated ai.h2o.mlops.monitoring.v2.ScoringAggregation aggregates = 1;
 */
aggregates?: ScoringAggregation[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Request message for CountAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.CountAggregatesRequest
 */
export type CountAggregatesRequest = {
/**
 * Required. The parent resource name of the aggregates to count them from.
 * Format: `workspaces/{workspace}/deployments/{deployment}/experiments/{experiment}` or
 *         `workspaces/{workspace}/jobs/{deployment}/experiments/{experiment}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Supported filter fields:
 * - id
 * - logical_type
 * - timestamp >= timestamp('2023-12-30T23:59:43Z') AND timestamp <= timestamp('2024-03-20T08:00:00Z')
 * - column_name
 *
 * @generated from field: string filter = 2;
 */
filter?: string;
}
;
/**
 * Response message for CountAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.CountAggregatesResponse
 */
export type CountAggregatesResponse = {
/**
 * Number of scoring aggregates
 *
 * @generated from field: int64 count = 1;
 */
count?: BigIntString;
}
;
/**
 * Request message for ListBaselineAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.ListBaselineAggregatesRequest
 */
export type ListBaselineAggregatesRequest = {
/**
 * Required. The parent resource name of the baseline aggregates to list them from.
 * Format: `workspaces/{workspace}/deployments/{deployment}/experiments/{experiment}` or
 *         `workspaces/{workspace}/jobs/{deployment}/experiments/{experiment}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return less items then specified.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
/**
 * Supported filter fields:
 * - column_id
 * - column_name
 *
 * @generated from field: string filter = 5;
 */
filter?: string;
}
;
/**
 * Response message for ListBaselineAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.ListBaselineAggregatesResponse
 */
export type ListBaselineAggregatesResponse = {
/**
 * Baseline Aggregates
 *
 * @generated from field: repeated ai.h2o.mlops.monitoring.v2.BaselineAggregation baseline_aggregates = 1;
 */
baselineAggregates?: BaselineAggregation[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Request message for CountBaselineAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.CountBaselineAggregatesRequest
 */
export type CountBaselineAggregatesRequest = {
/**
 * Required. The parent resource name of the baseline aggregates to count them from.
 * Format: `workspaces/{workspace}/deployments/{deployment}/experiments/{experiment}` or
 *         `workspaces/{workspace}/jobs/{deployment}/experiments/{experiment}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Supported filter fields:
 * - column_id
 * - column_name
 *
 * @generated from field: string filter = 2;
 */
filter?: string;
}
;
/**
 * Response message for CountBaselineAggregates
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.CountBaselineAggregatesResponse
 */
export type CountBaselineAggregatesResponse = {
/**
 * Number of baseline aggregates
 *
 * @generated from field: int64 count = 1;
 */
count?: BigIntString;
}
;
/**
 * List Aggregates for scoring data.
 *
 * @generated from rpc ai.h2o.mlops.monitoring.v2.AggregateService.ListAggregates
 */
export const AggregateService_ListAggregates = new RPC<ListAggregatesRequest,ListAggregatesResponse>("GET", "/v2/{parent=workspaces/*/deployments/*/experiments/*}/aggregates");
/**
 * Count Aggregates for scoring data.
 *
 * @generated from rpc ai.h2o.mlops.monitoring.v2.AggregateService.CountAggregates
 */
export const AggregateService_CountAggregates = new RPC<CountAggregatesRequest,CountAggregatesResponse>("GET", "/v2/{parent=workspaces/*/deployments/*/experiments/*}/aggregates:count");
/**
 * List Baseline Aggregates
 *
 * @generated from rpc ai.h2o.mlops.monitoring.v2.AggregateService.ListBaselineAggregates
 */
export const AggregateService_ListBaselineAggregates = new RPC<ListBaselineAggregatesRequest,ListBaselineAggregatesResponse>("GET", "/v2/{parent=workspaces/*/deployments/*/experiments/*}/baselineAggregates");
/**
 * Count Baseline Aggregates
 *
 * @generated from rpc ai.h2o.mlops.monitoring.v2.AggregateService.CountBaselineAggregates
 */
export const AggregateService_CountBaselineAggregates = new RPC<CountBaselineAggregatesRequest,CountBaselineAggregatesResponse>("GET", "/v2/{parent=workspaces/*/deployments/*/experiments/*}/baselineAggregates:count");
